import React from 'react';
import {connect} from 'react-redux';

import {BaseRate, mapStateToProps} from '../../../grid-control/components/rates/BaseRate.jsx';

import {addCouponRate as addCouponRateAction, addRate as addRateAction} from 'actions/creators/CouponRate';
import {makeBet as makeBetAction} from 'actions/creators/MakeBet';
import {requestBetTypes as requestBetTypesAction} from 'actions/creators/HistoryBet';

import {getRateDisplayValue} from 'rendering-commons';

class PopularMatchRate extends BaseRate {
    static propTypes = {
        rate: React.PropTypes.object,
        addCouponRateAction: React.PropTypes.func.isRequired,
        gridLocalization: React.PropTypes.object.isRequired,
        addRateAction: React.PropTypes.func.isRequired,
        makeBetAction: React.PropTypes.func.isRequired,
        requestBetTypesAction: React.PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
    }

    render() {
        const {rate} = this.props;

        if (!rate) {
            return (<span className="cell rate empty-cell"/>);
        }

        const rateValue = getRateDisplayValue(rate.get('value'));

        return (<span className="cell rate" onClick={this._onClick}>{rateValue}</span>);
    }
}

export default connect(mapStateToProps, {
    addCouponRateAction, makeBetAction, requestBetTypesAction, addRateAction
}, null, false)(PopularMatchRate);



// WEBPACK FOOTER //
// ./js/sport-betting/components/main-page/banners/popular-match-rate/PopularMatchRate.jsx